import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@/components/ui/button';

export const PAGINATION_PAGE_SIZE = 10;

interface PaginationProps {
  currentPage: number;
  totalItems: number;
  onPageChange: (page: number) => void;
  pageSize?: number;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalItems,
  onPageChange,
  pageSize = PAGINATION_PAGE_SIZE,
}) => {
  const totalPages = Math.max(1, Math.ceil(totalItems / pageSize));
  const start = totalItems === 0 ? 0 : (currentPage - 1) * pageSize + 1;
  const end = Math.min(currentPage * pageSize, totalItems);

  return (
    <div className="flex items-center justify-between gap-4 w-full">
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => onPageChange(Math.max(1, currentPage - 1))}
        disabled={currentPage === 1}
        className="bg-white border-gray-200 shadow-sm rounded-md hover:bg-gray-50 gap-2"
      >
        <ChevronLeft className="h-4 w-4 text-gray-700" />
        <span className="text-gray-700">Previous</span>
      </Button>
      <span className="text-sm text-[#0A0A0A] whitespace-nowrap">
        {start}-{end} <span className="text-gray-500">of {totalItems}</span>
      </span>
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={() => onPageChange(Math.min(totalPages, currentPage + 1))}
        disabled={currentPage >= totalPages}
        className="bg-white border-gray-200 shadow-sm rounded-md hover:bg-gray-50 gap-2"
      >
        <span className="text-gray-700">Next</span>
        <ChevronRight className="h-4 w-4 text-gray-700" />
      </Button>
    </div>
  );
};
